import { EventEmitter } from '@angular/core';
import { ServiceCodes, UnitOfMeasurementCodes } from '@common/classes/codes';
import { round } from '@common/classes/math';
import { EditableGridComponent } from '@common/components/editable-grid/editable-grid.component';
import { environment } from '@environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@angular/forms";
import * as i3 from "@fortawesome/angular-fontawesome";
import * as i4 from "@progress/kendo-angular-grid";
import * as i5 from "../../../common/components/app-control/app-control.component";
import * as i6 from "../../../common/components/app-grid/app-grid.component";
import * as i7 from "../../../common/components/editable-grid/editable-grid.component";
import * as i8 from "../../../common/components/popover-list/popover-list.component";
import * as i9 from "@ngx-translate/core";
import * as i10 from "../../../common/pipes/codelist.pipe";
const _c0 = function (a0) {
  return {
    disabled: a0
  };
};
function InvoiceItemListComponent_kendo_grid_column_1_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15);
    i0.ɵɵlistener("click", function InvoiceItemListComponent_kendo_grid_column_1_ng_template_1_Template_div_click_1_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r19);
      const dataItem_r17 = restoredCtx.dataItem;
      const ctx_r18 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r18.moveRow(dataItem_r17, "up"));
    });
    i0.ɵɵelement(2, "fa-icon", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 15);
    i0.ɵɵlistener("click", function InvoiceItemListComponent_kendo_grid_column_1_ng_template_1_Template_div_click_3_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r19);
      const dataItem_r17 = restoredCtx.dataItem;
      const ctx_r20 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r20.moveRow(dataItem_r17, "down"));
    });
    i0.ɵɵelement(4, "fa-icon", 17);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const dataItem_r17 = ctx.dataItem;
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0, dataItem_r17.sequenceNumber === ctx_r16.minItemSequenceNumber));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0, dataItem_r17.sequenceNumber === ctx_r16.maxItemSequenceNumber));
  }
}
function InvoiceItemListComponent_kendo_grid_column_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "kendo-grid-column", 13);
    i0.ɵɵtemplate(1, InvoiceItemListComponent_kendo_grid_column_1_ng_template_1_Template, 5, 6, "ng-template", 4);
    i0.ɵɵelementEnd();
  }
}
function InvoiceItemListComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 18);
    i0.ɵɵlistener("ngModelChange", function InvoiceItemListComponent_ng_template_4_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r23);
      const dataItem_r21 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r21.serviceId = $event);
    })("ngModelChange", function InvoiceItemListComponent_ng_template_4_Template_app_control_ngModelChange_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r23);
      const dataItem_r21 = restoredCtx.dataItem;
      const ctx_r24 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r24.onServiceChange(dataItem_r21));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r21 = ctx.dataItem;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isDisabled", ctx_r1.isCreditNote)("ngModel", dataItem_r21.serviceId)("entity", dataItem_r21);
  }
}
function InvoiceItemListComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const dataItem_r25 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, dataItem_r25.serviceId, "Service")), " ");
  }
}
function InvoiceItemListComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 19);
    i0.ɵɵlistener("ngModelChange", function InvoiceItemListComponent_ng_template_8_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r28);
      const dataItem_r26 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r26.description = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r26 = ctx.dataItem;
    i0.ɵɵproperty("ngModel", dataItem_r26.description)("entity", dataItem_r26);
  }
}
function InvoiceItemListComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const dataItem_r29 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", dataItem_r29.description, " ");
  }
}
function InvoiceItemListComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 20);
    i0.ɵɵlistener("ngModelChange", function InvoiceItemListComponent_ng_template_12_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r32);
      const dataItem_r30 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r30.quantity = $event);
    })("ngModelChange", function InvoiceItemListComponent_ng_template_12_Template_app_control_ngModelChange_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r32);
      const dataItem_r30 = restoredCtx.dataItem;
      const ctx_r33 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r33.updateItem(dataItem_r30));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r30 = ctx.dataItem;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isDisabled", ctx_r5.automatic && ctx_r5.disabledEditIds[dataItem_r30.id] || ctx_r5.isCreditNote)("ngModel", dataItem_r30.quantity)("entity", dataItem_r30);
  }
}
function InvoiceItemListComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const dataItem_r34 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", dataItem_r34.quantity, " ");
  }
}
function InvoiceItemListComponent_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 21);
    i0.ɵɵlistener("ngModelChange", function InvoiceItemListComponent_ng_template_16_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r37);
      const dataItem_r35 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r35.unitOfMeasurementId = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r35 = ctx.dataItem;
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isDisabled", ctx_r7.disabledEditIds[dataItem_r35.id] || ctx_r7.isCreditNote)("ngModel", dataItem_r35.unitOfMeasurementId)("entity", dataItem_r35);
  }
}
function InvoiceItemListComponent_ng_template_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const dataItem_r38 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, dataItem_r38.unitOfMeasurementId, "UnitOfMeasurement")), " ");
  }
}
function InvoiceItemListComponent_ng_template_20_Template(rf, ctx) {
  if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 22);
    i0.ɵɵlistener("ngModelChange", function InvoiceItemListComponent_ng_template_20_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r41);
      const dataItem_r39 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r39.pricePerUnit = $event);
    })("ngModelChange", function InvoiceItemListComponent_ng_template_20_Template_app_control_ngModelChange_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r41);
      const dataItem_r39 = restoredCtx.dataItem;
      const ctx_r42 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r42.updateItem(dataItem_r39));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r39 = ctx.dataItem;
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isDisabled", ctx_r9.isCreditNote)("ngModel", dataItem_r39.pricePerUnit)("entity", dataItem_r39);
  }
}
function InvoiceItemListComponent_ng_template_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "number");
  }
  if (rf & 2) {
    const dataItem_r43 = ctx.$implicit;
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind2(1, 2, dataItem_r43.pricePerUnit, "0.2-2"), " ", ctx_r10.currency, " ");
  }
}
function InvoiceItemListComponent_ng_template_24_Template(rf, ctx) {
  if (rf & 1) {
    const _r46 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 23);
    i0.ɵɵlistener("ngModelChange", function InvoiceItemListComponent_ng_template_24_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r46);
      const dataItem_r44 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r44.taxId = $event);
    })("ngModelChange", function InvoiceItemListComponent_ng_template_24_Template_app_control_ngModelChange_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r46);
      const dataItem_r44 = restoredCtx.dataItem;
      const ctx_r47 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r47.updateItem(dataItem_r44));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r44 = ctx.dataItem;
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isDisabled", ctx_r11.isCreditNote)("ngModel", dataItem_r44.taxId)("entity", dataItem_r44);
  }
}
function InvoiceItemListComponent_ng_template_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const dataItem_r48 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, dataItem_r48.taxId, "TaxRate")), " ");
  }
}
function InvoiceItemListComponent_ng_template_28_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "number");
  }
  if (rf & 2) {
    const dataItem_r49 = ctx.$implicit;
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind2(1, 2, dataItem_r49 == null ? null : dataItem_r49.amount, "0.2-2"), " ", ctx_r13.currency, " ");
  }
}
function InvoiceItemListComponent_ng_template_31_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "number");
  }
  if (rf & 2) {
    const dataItem_r50 = ctx.$implicit;
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind2(1, 2, dataItem_r50 == null ? null : dataItem_r50.totalAmount, "0.2-2"), " ", ctx_r14.currency, " ");
  }
}
function InvoiceItemListComponent_32_ng_template_0_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r59 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r59.serviceId, "Service")), " ");
  }
}
const _c1 = function (a0) {
  return {
    text: a0,
    separator: ";",
    width: "250px"
  };
};
function InvoiceItemListComponent_32_ng_template_0_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-popover-list", 25);
  }
  if (rf & 2) {
    const dataItem_r60 = ctx.$implicit;
    i0.ɵɵproperty("data", i0.ɵɵpureFunction1(1, _c1, dataItem_r60.description));
  }
}
function InvoiceItemListComponent_32_ng_template_0_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r63 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 30);
    i0.ɵɵlistener("ngModelChange", function InvoiceItemListComponent_32_ng_template_0_ng_template_9_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r63);
      const dataItem_r61 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r61.from = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r61 = ctx.dataItem;
    const ctx_r55 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("isDisabled", ctx_r55.isCreditNote)("ngModel", dataItem_r61.from)("entity", dataItem_r61);
  }
}
function InvoiceItemListComponent_32_ng_template_0_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r66 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 31);
    i0.ɵɵlistener("ngModelChange", function InvoiceItemListComponent_32_ng_template_0_ng_template_12_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r66);
      const dataItem_r64 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r64.to = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r64 = ctx.dataItem;
    const ctx_r56 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("isDisabled", ctx_r56.isCreditNote)("ngModel", dataItem_r64.to)("entity", dataItem_r64);
  }
}
function InvoiceItemListComponent_32_ng_template_0_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r69 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 32);
    i0.ɵɵlistener("ngModelChange", function InvoiceItemListComponent_32_ng_template_0_ng_template_15_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r69);
      const dataItem_r67 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r67.total = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r67 = ctx.dataItem;
    const ctx_r57 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("isDisabled", ctx_r57.isCreditNote)("ngModel", dataItem_r67.total)("entity", dataItem_r67);
  }
}
function InvoiceItemListComponent_32_ng_template_0_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "number");
  }
  if (rf & 2) {
    const row_r70 = ctx.$implicit;
    const ctx_r58 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind2(1, 2, row_r70.total, "1.2-2"), " ", ctx_r58.currency, " ");
  }
}
function InvoiceItemListComponent_32_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "app-grid", 25)(1, "kendo-grid-column", 2);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, InvoiceItemListComponent_32_ng_template_0_ng_template_3_Template, 3, 6, "ng-template", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "kendo-grid-column", 26);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵtemplate(6, InvoiceItemListComponent_32_ng_template_0_ng_template_6_Template, 1, 3, "ng-template", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "kendo-grid-column", 27);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵtemplate(9, InvoiceItemListComponent_32_ng_template_0_ng_template_9_Template, 1, 3, "ng-template", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "kendo-grid-column", 28);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵtemplate(12, InvoiceItemListComponent_32_ng_template_0_ng_template_12_Template, 1, 3, "ng-template", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "kendo-grid-column", 29);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵtemplate(15, InvoiceItemListComponent_32_ng_template_0_ng_template_15_Template, 1, 3, "ng-template", 3);
    i0.ɵɵtemplate(16, InvoiceItemListComponent_32_ng_template_0_ng_template_16_Template, 2, 5, "ng-template", 4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const dataItem_r52 = ctx.$implicit;
    i0.ɵɵproperty("data", dataItem_r52.chargeCandidates);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 6, "Service"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(5, 8, "Description"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(8, 10, "Charge From"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(11, 12, "Charge To"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(14, 14, "Total"));
  }
}
function InvoiceItemListComponent_32_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, InvoiceItemListComponent_32_ng_template_0_Template, 17, 16, "ng-template", 24);
  }
}
const _c2 = function () {
  return {
    enabled: true,
    checkboxOnly: true
  };
};
export class InvoiceItemListComponent {
  constructor() {
    this.editMode = false;
    this.automatic = false;
    this.isCreditNote = false;
    this.totalsUpdated = new EventEmitter();
    this.currency = environment.settings.currency;
    this.selection = [];
    this.disabledEditIds = {};
    this.gridSort = [{
      field: 'sequenceNumber',
      dir: 'asc'
    }];
  }
  get canDelete() {
    return !this.automatic && !this.isCreditNote;
  }
  get maxItemSequenceNumber() {
    return Math.max(...this.items.map(item => item.sequenceNumber));
  }
  get minItemSequenceNumber() {
    return Math.min(...this.items.map(item => item.sequenceNumber));
  }
  ngOnInit() {
    // Angular change detection workaround
    setTimeout(() => {
      this.initializeItems();
    });
    this.itemCreateParameters = {
      taxId: 'VAT0'
    };
    this.createParamsSequenceNumber();
  }
  initializeItems() {
    if (this.automatic) this.items.forEach(item => this.onServiceChange(item));
  }
  isInvoiceItemDisabled(vesselVisitServiceId) {
    return vesselVisitServiceId !== null;
  }
  onServiceChange(item) {
    switch (item.serviceId) {
      case ServiceCodes.AnchorageDues:
      case ServiceCodes.BerthageDues:
        item.unitOfMeasurementId = UnitOfMeasurementCodes.LengthOverall;
        break;
      case ServiceCodes.LaidUpDues:
      case ServiceCodes.PortDues:
        item.unitOfMeasurementId = UnitOfMeasurementCodes.NetTonnage;
        break;
      case ServiceCodes.WasteManagementFee:
        item.unitOfMeasurementId = UnitOfMeasurementCodes.GrossTonnage;
        break;
      default:
        item.unitOfMeasurementId = UnitOfMeasurementCodes.Other;
        break;
    }
    item.quantity = !!item.unitOfMeasurementId ? 1 : null;
    this.disabledEditIds[item.id] = !!item.unitOfMeasurementId;
  }
  updateItem(dataItemOrSaveEvent) {
    var item = dataItemOrSaveEvent?.dataItem ?? dataItemOrSaveEvent;
    item.entityAspect.loadNavigationProperty('tax').then(() => {
      const amount = item.pricePerUnit * item.quantity;
      item.amount = round(amount, environment.settings.roundingSettings.amount);
      item.taxAmount = round(item.tax?.rate / 100.0 * item.amount, environment.settings.roundingSettings.taxAmount) || 0;
      item.totalAmount = round(item.amount + item.taxAmount, environment.settings.roundingSettings.amount) || 0;
      const total = {
        amount: 0,
        taxAmount: 0,
        totalAmount: 0
      };
      this.items.forEach(el => {
        total.amount += el.amount;
        total.taxAmount += el.taxAmount;
        total.totalAmount += el.totalAmount;
      });
      this.totalsUpdated.emit(total);
    });
  }
  removeItem(event) {
    var item = event.dataItem;
    this.createParamsSequenceNumber();
    const total = {
      amount: item.amount * -1,
      taxAmount: item.taxAmount * -1,
      totalAmount: item.totalAmount * -1
    };
    this.totalsUpdated.emit(total);
  }
  addItem(event) {
    this.createParamsSequenceNumber();
  }
  previousItem(sequenceNumber, items) {
    const seqNum = items.map(item => item.sequenceNumber).filter(seqNum => seqNum < sequenceNumber).sort((a, b) => b - a)[0];
    return items.filter(item => item.sequenceNumber === seqNum)[0];
  }
  nextItem(sequenceNumber, items) {
    const seqNum = items.map(item => item.sequenceNumber).filter(seqNum => seqNum > sequenceNumber).sort((a, b) => a - b)[0];
    return items.filter(item => item.sequenceNumber === seqNum)[0];
  }
  moveRow(item, direction) {
    console.log(item.sequenceNumber);
    if (item.sequenceNumber === this.minItemSequenceNumber && direction === 'up' || item.sequenceNumber === this.maxItemSequenceNumber && direction === 'down') return;
    let otherItem;
    if (direction === 'up') {
      otherItem = this.previousItem(item.sequenceNumber, this.items);
    }
    if (direction === 'down') {
      otherItem = this.nextItem(item.sequenceNumber, this.items);
    }
    const otherSeqNumber = otherItem.sequenceNumber;
    otherItem.sequenceNumber = item.sequenceNumber;
    item.sequenceNumber = otherSeqNumber;
    this.appGrid.onDataStateChange();
  }
  createParamsSequenceNumber() {
    this.itemCreateParameters.sequenceNumber = this.items.length > 0 ? this.maxItemSequenceNumber + 1 : 0;
  }
}
InvoiceItemListComponent.ɵfac = function InvoiceItemListComponent_Factory(t) {
  return new (t || InvoiceItemListComponent)();
};
InvoiceItemListComponent.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
  type: InvoiceItemListComponent,
  selectors: [["app-invoice-item-list"]],
  viewQuery: function InvoiceItemListComponent_Query(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵviewQuery(EditableGridComponent, 5);
    }
    if (rf & 2) {
      let _t;
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.appGrid = _t.first);
    }
  },
  inputs: {
    items: "items",
    totals: "totals",
    editMode: "editMode",
    automatic: "automatic",
    isCreditNote: "isCreditNote"
  },
  outputs: {
    totalsUpdated: "totalsUpdated"
  },
  decls: 33,
  vars: 35,
  consts: [["entityName", "InvoiceItem", 3, "data", "sort", "createParameters", "editMode", "selectable", "canAddNew", "canDelete", "selection", "selectionChange", "remove", "add", "save"], ["width", "20", 4, "ngIf"], ["field", "serviceId", 3, "title"], ["kendoGridEditTemplate", ""], ["kendoGridCellTemplate", ""], ["field", "description", 3, "title"], ["field", "quantity", 3, "title"], ["field", "unitOfMeasurementId", 3, "title"], ["field", "pricePerUnit", 3, "title"], ["field", "tax.id", 3, "title"], ["field", "amount", 3, "title"], ["field", "totalAmount", 3, "title"], [4, "ngIf"], ["width", "20"], [1, "seq-buttons"], [1, "seq-button", 3, "ngClass", "click"], ["icon", "caret-up"], ["icon", "caret-down"], ["type", "codelist", "codelist", "Service", "property", "serviceId", 3, "isDisabled", "ngModel", "entity", "ngModelChange"], ["property", "description", 3, "ngModel", "entity", "ngModelChange"], ["type", "number", "property", "quantity", 3, "isDisabled", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "UnitOfMeasurement", "property", "unitOfMeasurementId", 3, "isDisabled", "ngModel", "entity", "ngModelChange"], ["type", "number", "property", "pricePerUnit", 3, "isDisabled", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "TaxRate", "property", "taxId", 3, "isDisabled", "ngModel", "entity", "ngModelChange"], ["kendoGridDetailTemplate", ""], [3, "data"], ["field", "description", "width", "250", 3, "title"], ["field", "from", "format", "g", 3, "title"], ["field", "to", "format", "g", 3, "title"], ["field", "total", 3, "title"], ["type", "datetime", "property", "from", 3, "isDisabled", "ngModel", "entity", "ngModelChange"], ["type", "datetime", "property", "to", 3, "isDisabled", "ngModel", "entity", "ngModelChange"], ["type", "number", "property", "total", 3, "isDisabled", "ngModel", "entity", "ngModelChange"]],
  template: function InvoiceItemListComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelementStart(0, "app-editable-grid", 0);
      i0.ɵɵlistener("selectionChange", function InvoiceItemListComponent_Template_app_editable_grid_selectionChange_0_listener($event) {
        return ctx.selection = $event;
      })("remove", function InvoiceItemListComponent_Template_app_editable_grid_remove_0_listener($event) {
        return ctx.removeItem($event);
      })("add", function InvoiceItemListComponent_Template_app_editable_grid_add_0_listener($event) {
        return ctx.addItem($event);
      })("save", function InvoiceItemListComponent_Template_app_editable_grid_save_0_listener($event) {
        return ctx.updateItem($event);
      });
      i0.ɵɵtemplate(1, InvoiceItemListComponent_kendo_grid_column_1_Template, 2, 0, "kendo-grid-column", 1);
      i0.ɵɵelementStart(2, "kendo-grid-column", 2);
      i0.ɵɵpipe(3, "translate");
      i0.ɵɵtemplate(4, InvoiceItemListComponent_ng_template_4_Template, 1, 3, "ng-template", 3);
      i0.ɵɵtemplate(5, InvoiceItemListComponent_ng_template_5_Template, 3, 6, "ng-template", 4);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(6, "kendo-grid-column", 5);
      i0.ɵɵpipe(7, "translate");
      i0.ɵɵtemplate(8, InvoiceItemListComponent_ng_template_8_Template, 1, 2, "ng-template", 3);
      i0.ɵɵtemplate(9, InvoiceItemListComponent_ng_template_9_Template, 1, 1, "ng-template", 4);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(10, "kendo-grid-column", 6);
      i0.ɵɵpipe(11, "translate");
      i0.ɵɵtemplate(12, InvoiceItemListComponent_ng_template_12_Template, 1, 3, "ng-template", 3);
      i0.ɵɵtemplate(13, InvoiceItemListComponent_ng_template_13_Template, 1, 1, "ng-template", 4);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(14, "kendo-grid-column", 7);
      i0.ɵɵpipe(15, "translate");
      i0.ɵɵtemplate(16, InvoiceItemListComponent_ng_template_16_Template, 1, 3, "ng-template", 3);
      i0.ɵɵtemplate(17, InvoiceItemListComponent_ng_template_17_Template, 3, 6, "ng-template", 4);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(18, "kendo-grid-column", 8);
      i0.ɵɵpipe(19, "translate");
      i0.ɵɵtemplate(20, InvoiceItemListComponent_ng_template_20_Template, 1, 3, "ng-template", 3);
      i0.ɵɵtemplate(21, InvoiceItemListComponent_ng_template_21_Template, 2, 5, "ng-template", 4);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(22, "kendo-grid-column", 9);
      i0.ɵɵpipe(23, "translate");
      i0.ɵɵtemplate(24, InvoiceItemListComponent_ng_template_24_Template, 1, 3, "ng-template", 3);
      i0.ɵɵtemplate(25, InvoiceItemListComponent_ng_template_25_Template, 3, 6, "ng-template", 4);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(26, "kendo-grid-column", 10);
      i0.ɵɵpipe(27, "translate");
      i0.ɵɵtemplate(28, InvoiceItemListComponent_ng_template_28_Template, 2, 5, "ng-template", 4);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(29, "kendo-grid-column", 11);
      i0.ɵɵpipe(30, "translate");
      i0.ɵɵtemplate(31, InvoiceItemListComponent_ng_template_31_Template, 2, 5, "ng-template", 4);
      i0.ɵɵelementEnd();
      i0.ɵɵtemplate(32, InvoiceItemListComponent_32_Template, 1, 0, null, 12);
      i0.ɵɵelementEnd();
    }
    if (rf & 2) {
      i0.ɵɵproperty("data", ctx.items)("sort", ctx.gridSort)("createParameters", ctx.itemCreateParameters)("editMode", ctx.editMode)("selectable", i0.ɵɵpureFunction0(34, _c2))("canAddNew", !ctx.automatic)("canDelete", ctx.canDelete)("selection", ctx.selection);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.editMode);
      i0.ɵɵadvance(1);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(3, 18, "Service"));
      i0.ɵɵadvance(4);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(7, 20, "Description"));
      i0.ɵɵadvance(4);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(11, 22, "Quantity"));
      i0.ɵɵadvance(4);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(15, 24, "Unit Of Measurement"));
      i0.ɵɵadvance(4);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(19, 26, "Price Per Unit"));
      i0.ɵɵadvance(4);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(23, 28, "VAT Amount (%)"));
      i0.ɵɵadvance(4);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(27, 30, "Amount"));
      i0.ɵɵadvance(3);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(30, 32, "Total Amount"));
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("ngIf", ctx.automatic);
    }
  },
  dependencies: [i1.NgClass, i1.NgIf, i2.NgControlStatus, i2.NgModel, i3.FaIconComponent, i4.ColumnComponent, i4.DetailTemplateDirective, i4.CellTemplateDirective, i4.EditTemplateDirective, i5.AppControlComponent, i6.AppGridComponent, i7.EditableGridComponent, i8.PopoverListComponent, i1.AsyncPipe, i1.DecimalPipe, i9.TranslatePipe, i10.CodelistPipe],
  styles: [".seq-buttons {\n  text-align: center;\n}\n.seq-buttons .seq-button {\n  cursor: pointer;\n  font-size: 1rem;\n}\n.seq-buttons .seq-button:hover {\n  color: #007bff;\n}\n.seq-buttons .seq-button.disabled {\n  color: #b8c7ce;\n  cursor: default;\n}\n.seq-buttons .seq-button:first-of-type fa-icon,\n.seq-buttons .seq-button:first-of-type svg {\n  vertical-align: bottom;\n}\n.seq-buttons .seq-button:last-of-type fa-icon,\n.seq-buttons .seq-button:last-of-type svg {\n  vertical-align: top;\n}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9hcHAvaW52b2ljZS9jb21wb25lbnRzL2ludm9pY2UtaXRlbS1saXN0L2ludm9pY2UtaXRlbS1saXN0LmNvbXBvbmVudC5zY3NzIiwid2VicGFjazovLy4vc3JjL2Fzc2V0cy9zY3NzL3ZhcmlhYmxlcy5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBO0VBQ0ksa0JBQUE7QUFESjtBQUdJO0VBQ0ksZUFBQTtFQUNBLGVBQUE7QUFEUjtBQUdRO0VBQ0ksY0M2Qkw7QUQ5QlA7QUFJUTtFQUNJLGNDaUJMO0VEaEJLLGVBQUE7QUFGWjtBQU1ZOztFQUVJLHNCQUFBO0FBSmhCO0FBU1k7O0VBRUksbUJBQUE7QUFQaEIiLCJzb3VyY2VzQ29udGVudCI6WyJAaW1wb3J0ICcuLi8uLi8uLi8uLi9hc3NldHMvc2Nzcy92YXJpYWJsZXMuc2Nzcyc7XHJcblxyXG4uc2VxLWJ1dHRvbnMge1xyXG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xyXG5cclxuICAgIC5zZXEtYnV0dG9uIHtcclxuICAgICAgICBjdXJzb3I6IHBvaW50ZXI7XHJcbiAgICAgICAgZm9udC1zaXplOiAxcmVtO1xyXG5cclxuICAgICAgICAmOmhvdmVyIHtcclxuICAgICAgICAgICAgY29sb3I6ICRibHVlO1xyXG4gICAgICAgIH1cclxuXHJcbiAgICAgICAgJi5kaXNhYmxlZCB7XHJcbiAgICAgICAgICAgIGNvbG9yOiAkZ3JleTtcclxuICAgICAgICAgICAgY3Vyc29yOiBkZWZhdWx0O1xyXG4gICAgICAgIH1cclxuXHJcbiAgICAgICAgJjpmaXJzdC1vZi10eXBlIHtcclxuICAgICAgICAgICAgZmEtaWNvbixcclxuICAgICAgICAgICAgc3ZnIHtcclxuICAgICAgICAgICAgICAgIHZlcnRpY2FsLWFsaWduOiBib3R0b207XHJcbiAgICAgICAgICAgIH1cclxuICAgICAgICB9XHJcblxyXG4gICAgICAgICY6bGFzdC1vZi10eXBlIHtcclxuICAgICAgICAgICAgZmEtaWNvbixcclxuICAgICAgICAgICAgc3ZnIHtcclxuICAgICAgICAgICAgICAgIHZlcnRpY2FsLWFsaWduOiB0b3A7XHJcbiAgICAgICAgICAgIH1cclxuICAgICAgICB9XHJcbiAgICB9XHJcbn1cclxuIiwiJHRoZW1lLWNvbG9yczogKFxyXG4gICAgZGFyazogIzFlMjgyY1xyXG4pO1xyXG5cclxuJHRhYmxlLWNlbGwtcGFkZGluZzogMC41cmVtO1xyXG5cclxuLy8gRm9udFxyXG4kZm9udC1zaXplOiAxcmVtO1xyXG4kZm9udC1zaXplLXNtOiBjYWxjKCRmb250LXNpemUgKiAwLjg3NSk7XHJcbiRmb250LWNvbG9yOiAjMDAwO1xyXG5cclxuLy8gSW5wdXRzXHJcbiRpbnB1dC1oZWlnaHQ6IDM0cHg7XHJcbiRpbnB1dC1sYWJlbC1mb250LXdlaWdodDogNDAwO1xyXG4kaW5wdXQtZGlzYWJsZWQtY29sb3I6ICNlOWVjZWY7XHJcbiRpbnB1dC1mb2N1cy1jb2xvcjogIzg2YjdmZTtcclxuXHJcbi8vIEJvcmRlcnNcclxuJGNhcmQtYm9yZGVyLXJhZGl1czogMDtcclxuJGJvcmRlci1yYWRpdXM6IDAuNXJlbTtcclxuJGJvcmRlci1yYWRpdXMtbGc6IDA7XHJcbiRib3JkZXItcmFkaXVzLXNtOiAwLjEyNXJlbTtcclxuJGJ0bi1ib3JkZXItcmFkaXVzOiAwLjMzM3JlbTtcclxuJGRyb3Bkb3duLWJvcmRlci1yYWRpdXM6IDA7XHJcbiRpbnB1dC1ib3JkZXItcmFkaXVzOiAwO1xyXG4kaW5wdXQtYm9yZGVyLXJhZGl1cy1sZzogMDtcclxuJGlucHV0LWJvcmRlci1yYWRpdXMtc206IDA7XHJcblxyXG4vLyBDb2xvcnNcclxuJHdoaXRlOiAjZmZmO1xyXG4kd2hpdGUyOiAjZjFmMWYxO1xyXG4kZ3JleTogI2I4YzdjZTtcclxuJGdyZXkyOiAjNGI2NDZmO1xyXG4kZ3JleTM6ICMyYzNiNDE7XHJcbiRncmV5NDogIzMzMztcclxuJGJsYWNrOiAjMDAwO1xyXG5cclxuJHJlZDogI2RjMzU0NSAhZGVmYXVsdDtcclxuJGdyZWVuOiAjMmNkYTQzICFkZWZhdWx0O1xyXG4kYmx1ZTogIzAwN2JmZiAhZGVmYXVsdDtcclxuJGJsdWUyOiAjMjE5NmYzICFkZWZhdWx0O1xyXG4kYmx1ZTM6ICM3ZmJkZmYgIWRlZmF1bHQ7XHJcbiRibHVlLXQ6IHJnYmEoMiwgMTE3LCAyMTYsIDAuNykgIWRlZmF1bHQ7XHJcbiRhY2NlbnQ6ICRibHVlICFkZWZhdWx0O1xyXG4kc2Vjb25kYXJ5OiAjY2NjICFkZWZhdWx0O1xyXG4kYnJhbmQtcHJpbWFyeTogI2U2NzcyZSAhZGVmYXVsdDtcclxuJGJvcmRlci1jb2xvcjogI2RlZTJlNiAhZGVmYXVsdDtcclxuXHJcbi8vIGstdGFibGUgY29sb3JzXHJcbiRrLXRhYmxlLWhlYWRlcjogI2Y4ZjlmYTtcclxuJGstdGFibGUtc3RyaXBlOiAjZmZmO1xyXG4kay10YWJsZS1zZWxlY3RlZC1zdHJpcGU6ICNjMmRiZmU7XHJcbiRrLXRhYmxlLWFsdC1zdHJpcGU6ICNmMmYyZjI7XHJcbiRrLXRhYmxlLWFsdC1zZWxlY3RlZC1zdHJpcGU6ICNiYmQ0Zjc7XHJcbiJdLCJzb3VyY2VSb290IjoiIn0= */"],
  encapsulation: 2
});